import { render, staticRenderFns } from "./SuggestionGuestStatistics.vue?vue&type=template&id=805e8c84&"
import script from "./SuggestionGuestStatistics.vue?vue&type=script&lang=js&"
export * from "./SuggestionGuestStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('805e8c84')) {
      api.createRecord('805e8c84', component.options)
    } else {
      api.reload('805e8c84', component.options)
    }
    module.hot.accept("./SuggestionGuestStatistics.vue?vue&type=template&id=805e8c84&", function () {
      api.rerender('805e8c84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/calendar/calendar-event-handler/SuggestionGuestStatistics.vue"
export default component.exports